export const BACKEND = 'https://unsw-course-map-backend.vercel.app';